import React from "react";

export default function JS_OOPs() {
  return (
    <div className="tutorial-container">
      <h1>JS OOPs</h1>
      <p>This tutorial explains the concept of JS OOPs in JavaScript OOPs.</p>
    </div>
  );
}
